// extracted by mini-css-extract-plugin
export default {"PageStart":"Aoh_PageStart__jhh8u","Card":"Aoh_Card__5Wyha","CustomPageBar":"Aoh_CustomPageBar__Rj8xh"};